/**
 * 008-reporting-dashboards T008/T009 — moved out of `dashboard.tsx` unchanged (007's own tile,
 * already real). Drills through to `/inventory/exceptions`, the same `GET /stock/exceptions` list
 * `Exceptions.tsx` reads — the tile and the list can never disagree because neither computes a
 * second count (FR-016, FR-020). Drawn by `StatusCard`.
 */
import { PiWarningDuotone as AlertTriangle } from "react-icons/pi";
import { TileBoundary } from "./TileBoundary";
import { StatusCard, UnreadableStatusCard } from "./StatusCard";

const icon = <AlertTriangle aria-hidden className="size-5" />;

function unreadable(error: unknown) {
  return <UnreadableStatusCard title="Stock exceptions" icon={icon} error={error} fallback="Could not be read — this is not the same as zero exceptions." />;
}

export function StockExceptionsTile({ resolve }: { resolve: Promise<number> }) {
  return (
    <TileBoundary resolve={resolve} errorFallback={unreadable}>
      {(count) => (
        <StatusCard
          title="Stock exceptions"
          icon={icon}
          tone={count > 0 ? "destructive" : "success"}
          value={count}
          caption="SKUs with a negative on-hand or free-stock balance."
          link={{ to: "/inventory/exceptions", label: "Open the exceptions list" }}
        />
      )}
    </TileBoundary>
  );
}
